<template>
  <div>
    <b-row>
      <b-col>
        <search-box :get-data-list="getDataList" />
      </b-col>
      <b-col cols="auto">
        <is-transferred :get-data-list="getDataList" />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <donation-types />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <type-select />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <receipt-status />
      </b-col>
      <b-col
        cols="12"
      >
        <donation-groups />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <bank-accounts />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <safe-select />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <donate-dates />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <donate-amounts />
      </b-col>
      <b-col
        cols="12"
        class="text-center"
      >
        <b-button
          variant="primary"
          class="mr-1"
          @click="getDataList"
        >
          <FeatherIcon
            icon="FilterIcon"
          />
          Detaylı Arama
        </b-button>
        <b-button
          variant="success"
          :href="exportExcel"
          target="_blank"
        >
          <FeatherIcon
            icon="DownloadIcon"
          />
          Excel İndir
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import SearchBox from '@/views/Admin/Account_activities/Components/FilterCard/SearchBox.vue'
import DonationTypes from '@/views/Admin/Account_activities/Components/FilterCard/DonationTypes.vue'
import TypeSelect from '@/views/Admin/Account_activities/Components/FilterCard/TypeSelect.vue'
import DonationGroups from '@/views/Admin/Account_activities/Components/FilterCard/DonationGroups.vue'
import DonateDates from '@/views/Admin/Account_activities/Components/FilterCard/DonateDates.vue'
import DonateAmounts from '@/views/Admin/Account_activities/Components/FilterCard/DonateAmounts.vue'
import IsTransferred from '@/views/Admin/Account_activities/Components/FilterCard/IsTransferred.vue'
import BankAccounts from '@/views/Admin/Account_activities/Components/FilterCard/BankAccounts.vue'
import SafeSelect from '@/views/Admin/Account_activities/Components/FilterCard/SafeSelect.vue'
import ReceiptStatus from '@/views/Admin/Account_activities/Components/FilterCard/ReceiptStatus.vue'

export default {
  name: 'FilterCard',
  components: {
    BRow,
    BCol,
    BButton,
    SearchBox,
    DonationTypes,
    TypeSelect,
    DonationGroups,
    DonateDates,
    DonateAmounts,
    IsTransferred,
    BankAccounts,
    SafeSelect,
    ReceiptStatus,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
    exportExcel() {
      const downloadToken = localStorage.getItem('downloadToken')
      let url = this.$store.state.app.baseURL
      url += `/Exports/reports/account_activities?token=${downloadToken}`
      if (this.filterParams.id_account_types) {
        url += `&id_account_types=${this.filterParams.id_account_types}`
      }
      if (this.filterParams.id_types) {
        url += `&id_types=${this.filterParams.id_types}`
      }
      if (this.filterParams.id_donation_groups) {
        url += `&id_donation_groups=${this.filterParams.id_donation_groups}`
      }
      if (this.filterParams.id_bank_accounts) {
        url += `&id_bank_accounts=${this.filterParams.id_bank_accounts}`
      }
      if (this.filterParams.id_safes) {
        url += `&id_safes=${this.filterParams.id_safes}`
      }
      if (this.filterParams.min_amount) {
        url += `&min_amount=${this.filterParams.min_amount}`
      }
      if (this.filterParams.max_amount) {
        url += `&max_amount=${this.filterParams.max_amount}`
      }
      if (this.filterParams.receipt_status) {
        url += `&receipt_status=${this.filterParams.receipt_status}`
      }
      if (this.filterParams.sdate) {
        url += `&sdate=${this.filterParams.sdate}`
      }
      if (this.filterParams.sdate) {
        url += `&edate=${this.filterParams.edate}`
      }
      return url
    },
  },
}
</script>
